import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { notifyInfo } from '@repletoryreach/sdk-ui/notifications';
import { PUSH_WORKER } from '../../lib/push';

/**
 * Listens to the push worker (9 October 2026). While the console is open and in front, an alert arrives here and
 * shows as a toast rather than a notification; pressing a notification while a console tab is open brings that tab
 * forward at the alert's page.
 */
export function PushListener() {
  const navigate = useNavigate();
  useEffect(() => {
    if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;
    const onMessage = (event: MessageEvent) => {
      const d = event.data as { type?: string; title?: string; body?: string; link?: string } | null;
      if (!d || typeof d !== 'object') return;
      if (d.type === 'rr-push' && d.title) notifyInfo(d.body ?? '', d.title);
      if (d.type === 'rr-push-open' && typeof d.link === 'string' && d.link.startsWith('/') && !d.link.startsWith('//')) navigate(d.link);
    };
    navigator.serviceWorker.addEventListener('message', onMessage);
    // A worker registered on another visit is picked up again, so it keeps receiving after a reload.
    void navigator.serviceWorker.getRegistration(PUSH_WORKER).catch(() => undefined);
    return () => navigator.serviceWorker.removeEventListener('message', onMessage);
  }, [navigate]);
  return null;
}
